import { connection } from "./jsstore_con";
import Vue from "@/main";

export class SettingsService {
    constructor() {
        this.tableName = "Settings";
    }

    async insert(value, refresh = false) {
        let inserted = await connection.insert({
            into: this.tableName,
            values: [value],
            upsert: true
        }); 

        if (inserted > 0 && refresh) {
            Vue.$events.fire('RefreshSettingsObservable', false);
        }
    }
    
    async update(value, refresh = false) {
        let updated = await connection.update({
            in: this.tableName,
            set: {
                inbox: value.inbox,
                my_chats: value.my_chats
            },
            where: {
                instance_id: value.instance_id  
            }
        })
        if (updated > 0 && refresh) {
            Vue.$events.fire('RefreshSettingsObservable', false);
        }
    }
    
    async getByInstanceId(value) {
        return await connection.select({
            from: this.tableName,
            where: {
                instance_id: value
            }
        })
    }

    async clearTable(instance) {
        await connection.remove({
            from: this.tableName,
            where: {
                instance_id: { in: instance }
            }
        })
    }
}
